
import { Component, Vue, Prop } from 'vue-property-decorator';
import SvgDiagonalDriversLicense from '@/components/SvgDiagonalDriversLicense.vue';
import SvgDiagonalMyNumberCard from '@/components/SvgDiagonalMyNumberCard.vue';
import SvgDiagonalResidenceCard from '@/components/SvgDiagonalResidenceCard.vue';
// 特別永住者証明書は在留カードと同一の画像コンポーネントを使用
import SvgDiagonalSpecialPermanentResidentCertificate from '@/components/SvgDiagonalResidenceCard.vue';
import SvgDiagonalPassport1 from '@/components/SvgDiagonalPassport1.vue';
import SvgDiagonalPassport2 from '@/components/SvgDiagonalPassport2.vue';
import SvgDiagonalHealthInsuranceCard from '@/components/SvgDiagonalHealthInsuranceCard.vue';
import SvgDiagonalGeneralCard from '@/components/SvgDiagonalGeneralCard.vue';
import CameraPageShootCardDiagonalEffect1 from '@/components/CameraPageShootCardDiagonalEffect1.vue';
import CameraPageShootCardDiagonalEffect2 from '@/components/CameraPageShootCardDiagonalEffect2.vue';
import CameraPageShootCardDiagonalEffect3 from '@/components/CameraPageShootCardDiagonalEffect3.vue';
import CameraPageShootCardDiagonalEffect4 from '@/components/CameraPageShootCardDiagonalEffect4.vue';
import CameraPageShootCardDiagonalEffect5 from '@/components/CameraPageShootCardDiagonalEffect5.vue';
import CameraPageShootCardDiagonalEffect6 from '@/components/CameraPageShootCardDiagonalEffect6.vue';
import CameraPageShootCardDiagonalEffect7 from '@/components/CameraPageShootCardDiagonalEffect7.vue';
import CameraPageShootMessageNormal from '@/components/CameraPageShootMessageNormal.vue';
import CameraPageShootCardDiagonalHeader from '@/components/CameraPageShootCardDiagonalHeader.vue';
import { is, isPassport } from '@/util/idDoc';

@Component({
  components: {
    SvgDiagonalDriversLicense,
    SvgDiagonalMyNumberCard,
    SvgDiagonalResidenceCard,
    SvgDiagonalSpecialPermanentResidentCertificate,
    SvgDiagonalPassport1,
    SvgDiagonalPassport2,
    SvgDiagonalHealthInsuranceCard,
    CameraPageShootMessageNormal,
    CameraPageShootCardDiagonalHeader,
    SvgDiagonalGeneralCard,
    CameraPageShootCardDiagonalEffect1,
    CameraPageShootCardDiagonalEffect2,
    CameraPageShootCardDiagonalEffect3,
    CameraPageShootCardDiagonalEffect4,
    CameraPageShootCardDiagonalEffect5,
    CameraPageShootCardDiagonalEffect6,
    CameraPageShootCardDiagonalEffect7
  }
})
export default class Parts extends Vue {
  private effectStep: number = 0;

  @Prop({ type: Number, required: true })
  public cardWidth!: number;

  @Prop({ type: Number, required: true })
  public cardHeight!: number;

  private get guideTxtType(): string {
    return this.isIdDocPassport ? 'thickness' : 'diagonal';
  }

  private get isIdDocDriversLicense(): boolean {
    if (is(this.$store.state.camera.idDocType, 'drivers-license')) return true;
    if (is(this.$store.state.camera.idDocType, 'driving-history-certificate')) return true;

    return false;
  }

  private get isIdDocMyNumberCard(): boolean {
    if (is(this.$store.state.camera.idDocType, 'my-number-card')) return true;

    return false;
  }

  private get isIdDocResidenceCard(): boolean {
    if (is(this.$store.state.camera.idDocType, 'residence-card')) return true;

    return false;
  }

  private get isIdDocSpecialPermanentResidentCertificate(): boolean {
    if (is(this.$store.state.camera.idDocType, 'special-permanent-resident-certificate')) return true;

    return false;
  }

  private get isIdDocPassport(): boolean {
    if (isPassport(this.$store.state.camera.idDocType) === true) return true;
    return false;
  }

  private get isIdDocHealthInsuranceCard(): boolean {
    if (is(this.$store.state.camera.idDocType, 'health-insurance-card')) return true;

    return false;
  }

  private get isPassport1(): boolean {
    return this.isIdDocPassport && !this.$store.getters['camera/isPC'];
  }

  private get isPassport2(): boolean {
    return this.isIdDocPassport && this.$store.getters['camera/isPC'];
  }

  private get isGeneralCard(): boolean {
    return this.$store.getters['camera/isGeneralCard'];
  }

  private get effectType(): 'left' | 'right' | 'none' {
    if (this.isIdDocDriversLicense) return 'right';
    if (this.isIdDocMyNumberCard) return 'left';
    if (this.isIdDocResidenceCard) return 'right';
    if (this.isIdDocSpecialPermanentResidentCertificate) return 'right';
    if (this.isIdDocHealthInsuranceCard) return 'none';
    return 'none';
  }

  private get strokeSize(): number {
    return Math.ceil(this.cardWidth / 100);
  }

  private get cardCalcWidth(): number {
    const maxWidth: number = this.$store.state.camera.clippingDisplayWidth - this.strokeSize * 2;
    return Math.min(maxWidth, this.cardWidth);
  }

  private get cardCalcHeight(): number {
    return this.cardCalcWidth * (this.cardHeight / this.cardWidth);
  }

  private get frameSize(): { x: number; y: number; w: number; h: number } {
    const w: number = this.cardCalcWidth + this.strokeSize * 2;
    const h: number = this.cardCalcHeight + this.strokeSize * 2;
    const x: number = (this.$store.state.camera.displayWidth - w) / 2;
    const y: number = this.$store.state.camera.displayIdDocCenter - h / 2;
    return { x, y, w, h };
  }

  private get styleEffect(): { [key: string]: string } {
    const top: string = `${0}px`;
    const width: string = `${this.frameSize.w}px`;
    const isMirror: boolean = this.$store.getters['camera/isMirror'];
    const transforms: string[] = [];
    transforms.push(`translateY(${top})`);
    transforms.push(`scaleX(${isMirror ? -1 : 1})`);
    return { width, transform: transforms.join(' ') };
  }

  private get stylePassport(): { [key: string]: string } {
    // cardWidthが画面の90%
    // frameSize.h => 背景transparentの高さ
    // cardCalcHeight => 本人確認書類の自体の高さ(Svg時点で上下に少し余白有)
    // frameSize.y => 背景transparentの上部
    // frameSize.h - cardCalcHeight => strokeSize * 2 => 本人確認書類の高さ以外の全体余白
    const top: string = `${(this.frameSize.h - this.cardCalcHeight) / 2 + this.frameSize.y}px`;
    const width: string = `${this.$store.state.camera.clippingDisplayWidth}px`;
    const isMirror: boolean = this.$store.getters['camera/isMirror'];
    const transform: string = `scaleX(${isMirror ? -1 : 1})`;
    return { top, width, transform };
  }

  private get styleGeneralCard(): { [key: string]: string } {
    const top: string = `${this.frameSize.y + this.frameSize.h / 2}px`;
    const width: string = `${this.frameSize.w - this.strokeSize * 2}px`;
    const isMirror: boolean = this.$store.getters['camera/isMirror'];
    const transform: string = `translateY(-50%) scaleX(${isMirror ? -1 : 1})`;
    return { top, width, transform };
  }

  public async mounted(): Promise<void> {
    let isEffect: boolean = false;
    if (this.isIdDocDriversLicense) isEffect = true;
    if (this.isIdDocMyNumberCard) isEffect = true;
    if (this.isIdDocResidenceCard) isEffect = true;
    if (this.isIdDocSpecialPermanentResidentCertificate) isEffect = true;
    if (this.isIdDocHealthInsuranceCard) isEffect = true;

    if (!isEffect) {
      // 斜撮影演出なし
      this.effectStep = 0;
    } else {
      // 斜撮影演出あり
      const delay1: number = 1000;
      const delay2: number = 600;
      const delay3: number = 1000;
      this.effectStep = 1;
      await new Promise((resolve) => setTimeout(resolve, delay1));
      this.effectStep = 2;
      await new Promise((resolve) => setTimeout(resolve, delay2));
      this.effectStep = 3;
      await new Promise((resolve) => setTimeout(resolve, delay2));
      this.effectStep = 4;
      await new Promise((resolve) => setTimeout(resolve, delay2));
      this.effectStep = 5;
      await new Promise((resolve) => setTimeout(resolve, delay2));
      this.effectStep = 6;
      await new Promise((resolve) => setTimeout(resolve, delay2));
      this.effectStep = 7;
      await new Promise((resolve) => setTimeout(resolve, delay3));
      this.effectStep = 8;
    }
  }
}
